import React, { useRef, useCallback, useState, useEffect } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import { MediaQueries } from '../utils';
import { ProductCard } from '../Common';
import { Grid } from "swiper/modules";
import { NavLink } from 'react-router-dom';
// import required modules

export default function TopPicksCarouselProducts({ products, type, inner_bg }) {

  const { isMobile } = MediaQueries()

  const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const handleSlideChange = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  return (
    <div className={`carousel_products p-0`} style={{ background: !isMobile && inner_bg }}>
      <Swiper
        ref={sliderRef}
        modules={[Grid]}
        grid={type == 1 && isMobile && { rows: 2, fill: "row" }} // 2 rows
        onSwiper={(swiper) => {
          setIsBeginning(swiper.isBeginning);
          setIsEnd(swiper.isEnd);
        }}
        onSlideChange={handleSlideChange}
        breakpoints={{
          200: {
            slidesPerView: 1.3,
          },
          375: {
            slidesPerView: ((type == 2 && 1.7) || (type == 1 && 2)),
          },
          425: {
            slidesPerView: 2,
          },
          760: {
            slidesPerView: (type == 2 && 3 || type == 1 && 3.3),
          },
          1000: {
            slidesPerView: (type == 2 && 2 || type == 1 && 4.2 || type == 3 && 3.5),
          },
          1200: {
            slidesPerView: (type == 2 && 2.5 || type == 1 && 5.5 || type == 3 && 4.5),
          },
          1400: {
            slidesPerView: (type == 2 && 2.5 || type == 1 && 5.5 || type == 3 && 4.5),
          },
          1600: {
            slidesPerView: (type == 2 && 3.5 || type == 1 && 7.5 || type == 3 && 5.5),
          }
        }}
        spaceBetween={isMobile ? 8 : 15}
        className="carouselSwiper"
      >
        {
          products && products.length > 0 && products.map((item) => {
            var url = item.url.split("/");

            return (
              <SwiperSlide >
                {
                  item.hasOwnProperty('sku') ?
                    <>
                      {
                        url.length >= 2 ?
                          <NavLink to={`/details/${item.url}`} className={'text-decoration-none'}>
                            <ProductCard item={item} />
                          </NavLink>
                          :
                          <NavLink to={`/details/${item.url}/${item.sku}`} className={'text-decoration-none'}>
                            <ProductCard item={item} />
                          </NavLink>
                      }
                    </>
                    :
                    <NavLink to={`/details/${item.url}`} className={'text-decoration-none'}>
                      <ProductCard item={item} />
                    </NavLink>
                }
              </SwiperSlide>
            )
          })
        }
        
      </Swiper>
    </div>
  );
}
